<div class="col-md-12 mb-30" [hidden]="Component_Swicher!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات دستگاه‌های مشتریان</h5>
      <br />
      <br />
      <div class="row">

        <div class="col-md-2">

        </div>

        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-check-circle highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> تعداد دستگاه های فعال </p>
                  <h4>{{ActiveCount}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-danger rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-times-circle-o highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> تعداد دستگاه های غیر فعال </p>
                  <h4>{{DisActiveCount}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام دستگاه</label>
          <input [(ngModel)]="Filter_title" name="Filter_title" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Device(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" routerLink="/DeviceAdd" type="button" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th (click)="ChangeOrder('id')">
                <i *ngIf="order=='id' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='id' && orderreverse" class="fa fa-sort-up"></i>
                شناسه دستگاه
              </th>
              <th (click)="ChangeOrder('title')">
                <i *ngIf="order=='title' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='title' && orderreverse" class="fa fa-sort-up"></i>
                نام دستگاه (لاتین)
              </th>
              <th (click)="ChangeOrder('quantity')">
                <i *ngIf="order=='quantity' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='quantity' && orderreverse" class="fa fa-sort-up"></i>
                کمیت
              </th>
              <th (click)="ChangeOrder('quantity_sub')">
                <i *ngIf="order=='quantity_sub' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='quantity_sub' && orderreverse" class="fa fa-sort-up"></i>
                زیر کمیت
              </th>
              <th>وضیعت</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>IP</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device
            | orderBy: order : orderreverse
            | paginate
                    : {
                        id: 'DataList_DeviceTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Device).length
                      }
            ">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.id}}</td>
              <td class="EnglishClm">{{item.title}}</td>
              <td>{{item.quantity}}</td>
              <td>{{item.quantity_sub}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>{{item.ip}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a class="dropdown-item" [routerLink]="['/DeviceEdit',{id:item.id}]"><i class="fa fa-edit"></i>
                        ویرایش </a>
                      <a style="cursor: pointer;" class="dropdown-item" (click)="Read_History(item)"><i
                          class="fa  fa-history"></i> تاریخچه تعرفه </a>

                      <a style="cursor: pointer;" class="dropdown-item" (click)="Read_Environment(item)"><i
                          class="fa fa-wpforms"></i> شرایط محیطی </a>
                      <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                      <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_DeviceTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Component_Swicher=='History'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> تاریخچه تعرفه های دستگاه '{{Data_Seleted_Delete.title}}' </h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-12">
          <button (click)="BackToList()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>توضیحات</th>
              <th>مبلغ واحد(ريال) - مشتری</th>
              <th>مبلغ واحد(ريال) - کارشناس</th>
              <th>تاریخ</th>
              <th>وضیعت</th>
              <th>کاربر</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Tariff_History
            |filter:Filter_title:'device_name'
            | paginate
                    : {
                        id: 'DataList_Tariff_History',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Tariff_History|filter:Filter_title:'device_name').length
                      }
            ">
              <td>{{DataList_Tariff_History.indexOf(item)+1}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.tariff|number}}</td>
              <td>{{item.tariff_expert|number}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.username}} </td>


            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_Tariff_History" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Component_Swicher=='Environment'">
  <app-DataEntityEnvironment [inner_Device]="Data_Seleted_Delete">
  </app-DataEntityEnvironment>

  <button (click)="BackToList()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

</div>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">تایید غیرفعال اطلاعات دستگاه
      '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">تایید فعال اطلاعات دستگاه
      '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> غیرفعال اطلاعات <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> فعال اطلاعات <i class="fa fa-unlock"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>شناسه دستگاه</th>
      <th>نام دستگاه (لاتین)</th>
      <th>کمیت</th>
      <th>زیر کمیت</th>
      <th>وضیعت</th>
      <th>تاریخ</th>
      <th>کاربر</th>
      <th>IP</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Device">
      <td>{{DataList_Device.indexOf(item)+1}}</td>
      <td>{{item.id}}</td>
      <td>{{item.title}}</td>
      <td>{{item.quantity}}</td>
      <td>{{item.quantity_sub}}</td>
      <td>
        <p *ngIf="!item.del">فعال</p>
        <p *ngIf="item.del">غیر فعال</p>
      </td>
      <td>{{item.persianDate}}</td>
      <td>{{item.username}} </td>
      <td>{{item.ip}} </td>
    </tr>
  </tbody>
</table>
